import { defaultAxios } from '@/services/index';

const gongService = {
  async createGongInfo(
    code: string,
    workspaceAlias: string,
    redirect_uri: string,
  ) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/gong/authenticated`,
        { code, redirect_uri },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async getGongInfo(alias: string) {
    try {
      const res = await defaultAxios.get(`/workspaces/${alias}/gong/`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async importGongFeedback(alias: string, startDate: string, endDate: string) {
    try {
      const res = await defaultAxios.post(`/gong/${alias}/import`, {
        start_date: startDate,
        end_date: endDate,
      });
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteGongInfo(alias: string) {
    try {
      const res = await defaultAxios.delete(`/gong/${alias}`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default gongService;
